
import React from 'react';


const HeaderWrapper = ({ children, withPadding }) => (
  <div style={{ color: 'var(--neutral--100)', padding: '0.5rem 1rem' }}>
    {children}
  </div>
);

export default HeaderWrapper;
